import React from 'react';
import PropTypes from 'prop-types';
import {
	Section,
	Container,
	H2,
	YoutubeVideo,
	MarkdownWrapper,
	Image,
} from 'components/atoms';

import './PSPVideo.scss';

const PSPVideo = ({ content }) => {
	const { title, description, videoSrc, imageSrc, suffixText } = content;

	return (
		<Section className="psplinear-gradient">
			<div className="title-video-section">
				<Container>
					<div className="video-section-container">
						{title && <H2 className="title">{title}</H2>}
						<MarkdownWrapper
							className="content-text"
							content={[{ value: description }]}
							componentProps={{ color: 'white' }}
						/>
						<div className="video-wrapper">
							{imageSrc ? (
								<Image
									src={imageSrc}
									alt={title}
								/>
							) : (
								<YoutubeVideo src={videoSrc} />
							)}
						</div>
						<div className="suffix-text">
							<MarkdownWrapper
								content={[{ value: suffixText }]}
								componentProps={{
									color: 'black',
									className: suffixText?.includes('https://')
										? 'bright-link'
										: '',
								}}
							/>
						</div>
					</div>
				</Container>
			</div>
		</Section>
	);
};

PSPVideo.propTypes = {
	content: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string,
		videoSrc: PropTypes.string.isRequired,
		suffixText: PropTypes.string,
		imageSrc: PropTypes.string,
	}),
};

export default PSPVideo;
